import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import {
  APPLICATION_COMMENT,
  APPLICATION_DETAILS,
  BILLING_CALCULATIONS,
} from "tagTypes";

export const useApplicationCommentQuery = (applicationId, query = {}) =>
  useGetQuery({
    endpoint: `/application/${applicationId}/application-comment`,
    query,
    tags: [APPLICATION_COMMENT],
  });

export const useAdminCommentsByIdQuery = (query = {}) =>
  useGetQuery({
    endpoint: "admin-comment",
    query,
    tags: [APPLICATION_COMMENT, APPLICATION_DETAILS, BILLING_CALCULATIONS],
  });

export const useLazyGetApplicationCommentQuery = () => {
  const [adminComments, data] = useLazyGetQuery();
  const adminComment = async (applicationId, query = {}) =>
    await adminComments(
      {
        endpoint: `/application/${applicationId}/application-comment`,
        query,
        tags: [APPLICATION_COMMENT],
      },
      true
    ).unwrap();
  return [adminComment, data];
};

export const useLazyAdminCommentQuery = () => {
  const [adminComments, data] = useLazyGetQuery();
  const adminComment = async (query = {}) =>
    await adminComments(
      {
        endpoint: "admin-comment",
        query,
        tags: [APPLICATION_COMMENT],
      },
      true
    ).unwrap();
  return [adminComment, data];
};

export const usePostApplicationCommentMutation = () => {
  const [applicationComments, data] = usePostMutation();
  const applicationComment = async (payload, query = {}) =>
    await applicationComments({
      endpoint: "/application-comment",
      query,
      payload: payload || {},
      toastMessage: "Application request comment added successfully",
      tags: [APPLICATION_COMMENT],
    }).unwrap();
  return [applicationComment, data];
};
